import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

import './employee-role.scss';

interface IProps {
  type: string;
}

export const CSEmployeeType: React.FC<IProps> = ({ type }) => {
  const popoverType = (
    <Popover id="popover-type">
      <Popover.Header as="h3">{type}</Popover.Header>
      <Popover.Body>
        {type === 'Counter' && (
          <>
            A Counter. High Deployment cost, but uses Special and Ultimate
            skills.
          </>
        )}
        {type === 'Mech' && (
          <>
            A combat weapon equipped with AI. Mechs have high basic stats and
            respond to enemies quickly.
          </>
        )}
        {type === 'Soldier' && (
          <>
            A man-at-arms. Soldiers have low stats, but they usually come in
            groups.
          </>
        )}
        {type === 'Corrupted Object' && (
          <>
            Corrupted Objects are cunning and deadly. Don't believe their lies.
          </>
        )}
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverType}
    >
      <div
        className={`employee-role ${type === 'Corrupted Object' ? 'CO' : type}`}
      >
        {type === 'Counter' && (
          <StaticImage
            src="../../../../images/counterside/icons/type_counter.png"
            alt="Counter"
          />
        )}
        {type === 'Mech' && (
          <StaticImage
            src="../../../../images/counterside/icons/type_mech.png"
            alt="Mech"
          />
        )}
        {type === 'Soldier' && (
          <StaticImage
            src="../../../../images/counterside/icons/type_soldier.png"
            alt="Soldier"
          />
        )}
        {type === 'Corrupted Object' && (
          <StaticImage
            src="../../../../images/counterside/icons/type_co.png"
            alt="Corrupted Object"
          />
        )}
        <span>{type === 'Corrupted Object' ? 'C.O.' : type}</span>
      </div>
    </OverlayTrigger>
  );
};
